<template>
  <div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else>
      <div v-if="formType !== 'edit'">
        <div>
          <form-accordion :title="$t('common.security.pem')" :isTitleUpperCase="false" >
            <b-row class="d-flex form-group">
              <!--b-col sm="6" class="form-group">
                <form-read-group-label-input :input-value="currentCA.idPod" isMandatory
                  :inputLabel="$t('common.security.pod_select')" :placeholderValue="$t('common.security.pod_select')">
                </form-read-group-label-input>
              </b-col-->
              <b-col sm="6" class="form-group">
                <form-read-group-label-input :input-value="currentCA.name" isMandatory
                  :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                </form-read-group-label-input>
              </b-col>
            </b-row>
          </form-accordion>
          <hr  class="mx-auto mb-4" />
          <form-accordion :title="$t('common.security.certificat')" :isTitleUpperCase="false">
            <b-row v-for="certificat in currentCA.Certificates" :key="certificat.id" class="d-flex align-items-center form-group">
              <b-col sm="4" class="form-group mb-5">
                <form-read-group-label-input :inputValue="certificat.name"
                  :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group mb-5">
                <form-read-group-label-input :inputValue="certificat.startDate"
                  :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group mb-5">
                <form-read-group-label-input :inputValue="certificat.endDate"
                  :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group mb-5">
                <form-read-group-label-input :inputValue="certificat.deliveredBy"
                  :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group mb-5">
                <form-read-group-label-input :inputValue="certificat.deliveredTo"
                  :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
                </form-read-group-label-input>
              </b-col>
              <b-col sm="4" class="form-group mb-5"></b-col>
            </b-row>
          </form-accordion>
        </div>
      </div>
      <div v-else>
        <ca-form-pem ref="caFormPem" :store="0" :certificate="currentCA.Certificates" :id="currentCA.id" :name="currentCA.name"></ca-form-pem>
      </div>
    </div>
  </div>
</template>
<script>

import _ from 'lodash'
import Spinner from '@/components/common/spinner.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import CAFormPEM from "@/pages/security/CAFormPEM.vue";

export default {
  name: 'CAFormGlobal',
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'spinner': Spinner,
    'ca-form-pem': CAFormPEM,
    AppButton

  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    listCertificateOutGroup () {
      return this.listCertificates.filter(elem => {
        return !elem.inGroup
      })
    },
    listCertificateInGroup () {
      return this.listCertificates.filter(elem => {
        return elem.inGroup
      })
    }
  },
  data: () => {
    return {
      activateSpinner: true,
      currentCA: {},
      fields: [],
      formType: 'add',
      name: '',
      pageTitle: '',
      listCertificates: [],
      refreshTab: false
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.getCertificates()
    this.fields.push({ key: 'name', tdClass: 'text-center '})
  },
  watch: {
    formType: {
      handler() {
        this.updateBottomActions()
      },
      immediate: true
    },
    currentCA: {
      handler() {
        this.updateBottomActions()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateBottomActions() {
      const actions = []
      
      if (this.isEditable && this.formType !== 'add') {
        actions.push({
          component: 'app-button',
          props: {
            text: this.$t('common.cncl'),
            variant: 'secondary'
          },
          handler: () => this.switchMode('details')
        })
      }
      
      if (!this.isEditable && this.formType !== 'add') {
        actions.push({
          component: 'app-button',
          props: {
            text: this.$t('administration.edit'),
            icon: 'fa-light fa-pencil',
            variant: 'primary'
          },
          handler: () => this.switchMode('edit')
        })
        
        actions.push({
          component: 'app-button',
          props: {
            text: this.$t('rights.delete'),
            icon: 'fa-light fa-trash',
            variant: 'secondary'
          },
          handler: () => this.deleteCA()
        })
      }
      
      if (this.isEditable && this.formType !== 'add') {
        actions.push({
          component: 'app-button',
          props: {
            text: this.$t('common.sve'),
            icon: 'fa-light fa-save',
            variant: 'primary'
          },
          handler: () => this.saveCA()
        })
      }
      
      if (this.mode === 'add') {
        actions.push({
          component: 'app-button',
          props: {
            text: this.$t('common.sve'),
            icon: 'fa-light fa-save',
            variant: 'primary'
          },
          handler: () => this.createCA()
        })
      }
      
      this.$emit('bottomActions', {
        show: actions.length > 0,
        actions: actions
      })
    },
    createCA () {
      let that = this
      if (this.formHasError()) {
        return
      }
      let params = {
        name: this.name,
        certificates: this.listCertificateInGroup.map(elem => elem.id),
      }
      this.$engine.firstOn().security.ca.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.ca_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/0'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.ca_addition_error'))
      })
    },
    saveCA() {
      // Appeler la méthode updateTruststore du composant CAFormPEM
      if (this.$refs.caFormPem) {
        this.$refs.caFormPem.updateTruststore()
      }
    },
    deleteCA () {
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.ca_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.firstOn().security.ca.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.ca_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/0'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.ca_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editCA () {
      let that = this
      let params = {
        name: this.name,
        id: this.id,
        certificates: this.listCertificateInGroup.map(elem => elem.id),
      }
      this.$engine.firstOn().security.ca.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.ca_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/0'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.ca_edit_error'))
      })
    },
    fillFields (CAList){
      this.name = CAList.name
      this.listCertificates.forEach(element => {
        element.inGroup = CAList.Certificates.map(elem => elem.id).includes(element.id)
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    formHasError () {
      if (this.name.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_name_missing'))
        return true
      }
      if (this.listCertificateInGroup.length === 0) {
        this.okMessageBox(this.$t('common.security.ca_cert_missing'))
        return true
      }
      return false
    },
    getCA () {
      let that = this
      this.$engine.firstOn().security.ca.fetch({id: this.id})
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca

        that.updateCA(CAList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getCertificates () {
      let that = this
      this.$engine.firstOn().security.certificates.fetch()
      .then(resp => {
        let certificatesList = {}

        certificatesList = resp.data.certificates
        that.updateCertificates(certificatesList)
        if(this.id !== '-1' && this.mode === "view"){
          this.getCA()
        }
        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRowSelectedInGroup (certificates) {
      for (let i = 0; i < this.listCertificateInGroup.length; i++) {
        this.listCertificateInGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    onRowSelectedOutGroup (certificates) {
      for (let i = 0; i < this.listCertificateOutGroup.length; i++) {
        this.listCertificateOutGroup[i].selected = false
      }
      for (let i = 0; i < certificates.length; i++) {
        certificates[i].selected = true
      }
      /* this.selectCertificate(certificates[0]) */
    },
    putAllCertificate (inGroup) {
      this.listCertificates.forEach(element => {
        element.inGroup = inGroup
        element.selected = false
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    putCertificateLeft () {
      this.listCertificates.forEach(element => {
        if (element.inGroup) {
          element.inGroup = !element.selected
          element.selected = false
        }
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    putCertificateRight () {
      this.listCertificates.forEach(element => {
        if (!element.inGroup) {
          element.inGroup = element.selected
          element.selected = false
        }
      })
      this.listCertificates = _.cloneDeep(this.listCertificates)
      this.refreshTab = !this.refreshTab
    },
    selectCertificate (certificate) {
      if(!this.isEditable){
        return
      }
      certificate.selected = !certificate.selected ? true : false
      this.refreshTab = !this.refreshTab
    },
    switchMode (mode) {
      this.formType = mode
      this.updateBottomActions()
    },
    updateCA (CAList) {
      this.currentCA = CAList[0]
      this.fillFields(this.currentCA)
    },
    updateCertificates (certificatesList) {
      this.listCertificates = certificatesList
    },
  }
}

</script>
